module.exports = __webpack_public_path__ + "img/underwear.36b944ba.svg";